import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixin from './mixins/main'
import sse from './sse'
import axios from 'axios'
import Cookies from 'vue-cookies'
import Trend from 'vuetrend'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { bundles } from '../config'
import '@mdi/font/scss/materialdesignicons.scss'
import './plugins/element.js'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    dsn: 'https://918afcb819ed4546b1a18ba1ba1628db@o273932.ingest.sentry.io/1489043',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    environment: process.env.NODE_ENV || 'production',
    tracesSampleRate: 1.0
  })
}

axios.defaults.baseURL = (process.env.VUE_APP_API || '') + '/'
axios.defaults.timeout = 60000

Vue.use(sse, store)
Vue.use(Cookies)
Vue.use(Trend)
Vue.mixin(mixin)
Vue.config.productionTip = false

Vue.api = axios.create()
Vue.api.interceptors.response.use((res) => res, (err) => {
  if (err.response && err.response.status === 401) {
    store.commit('logout')
    store.commit('reset')
  }
  return Promise.reject(err)
})

Vue.apiv4 = axios.create()
Vue.apiv4.defaults.baseURL = 'https://app.runstack.com/'

const language = (navigator ? navigator.language : 'en-CH').split('-')

new Vue({
  router,
  store,
  data () {
    return {
      bundles,
      language: {
        lang: language[0],
        country: (language[1] || 'CH').toUpperCase()
      },
      currency: {
        code: 'eur',
        symbol: '€'
      },
      recaptchaKey: process.env.VUE_APP_RECAPTCHA_KEY,
      githubClientId: process.env.VUE_APP_GITHUB_CLIENT_ID
    }
  },
  render: h => h(App)
}).$mount('#app')
